import * as React from 'react';

// Types
import { IManifestFieldHydrated } from '../../../manifests/types';

// Hooks
import { useDynamicRequired } from './useDynamicRequired';

// Manifest
// import { manifest } from '../../../manifests/questionManifest';

export const useCompleteness = () => {
    const { determineRequired } = useDynamicRequired();

    const computeCompleteness = ({
        manifest,
        formState,
        ancillaryData
    }: {
        manifest: IManifestFieldHydrated[];
        formState: Record<string, any>;
        ancillaryData?: Record<string, any>;
    }) => {
        const requiredStaticKeys = manifest
            .filter((field) => {
                return determineRequired({
                    required: field?.componentProps?.required,
                    values: formState,
                    ancillaryData: ancillaryData ?? {}
                });
            })
            .map(({ id }) => id);

        return (
            requiredStaticKeys.filter((key) => {
                return key && typeof formState?.[key] !== 'undefined' && formState?.[key] !== '';
            }).length / requiredStaticKeys.length
        );
    };

    return { computeCompleteness };
};

export default useCompleteness;
